import axios from '@/plugins/axios'

/**
 * Get accounts
 */
const getIntegrations = async () => {
  try {
    const response = await axios.get('integrations/list')
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Force refresh PixelMetrics
 */
const forceRefreshPixelMetrics = async ({
  // eslint-disable-next-line camelcase
  advertiser_id = null,
  // eslint-disable-next-line camelcase
  company_id = null
}) => {
  try {
    const params = {}
    // eslint-disable-next-line camelcase
    if (advertiser_id) params.advertiser_id = advertiser_id
    // eslint-disable-next-line camelcase
    if (company_id) params.company_id = company_id

    const response = await axios.get('pixelmetrics', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getIntegrations,
  forceRefreshPixelMetrics
}
